import React, { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';

import SectionWrapper from '../../../../message-response/components/section-wrapper/SectionWrapper';
import useResonanceLoadingState from '../../../../../hooks/useResonanceLoadingState';

import CompareFilter from '../compare-filter/CompareFilter';

function ConceptSection({ title, selectedConcept, isGlobalPercentageEnabled, children }) {
  const [compareConcepts, setCompareConcepts] = useState([]);
  const [isGlobalPercentage, setIsGlobalPercentage] = useState(false);

  const isConceptsLoading = useResonanceLoadingState('isConceptsLoading');

  const handleSelectCompareConcept = (concepts) => {
    setCompareConcepts(concepts);
  };

  useEffect(() => {
    if (!isGlobalPercentageEnabled) {
      setIsGlobalPercentage(false);
    }
  }, [isGlobalPercentageEnabled]);

  return (
    <SectionWrapper
      title={title}
      Filters={
        <CompareFilter
          selectedConcept={selectedConcept}
          selectedCompareConcepts={compareConcepts}
          onSelectCompareConcept={handleSelectCompareConcept}
          isGlobalPercentage={isGlobalPercentage}
          onChangeGlobalPercentage={setIsGlobalPercentage}
          isGlobalPercentageEnabled={isGlobalPercentageEnabled}
          isLoading={isConceptsLoading}
        />
      }>
      {isConceptsLoading ? (
        <Skeleton animation='wave' variant='rounded' height={350} />
      ) : (
        children({ compareConcepts, isGlobalPercentage })
      )}
    </SectionWrapper>
  );
}

export default ConceptSection;
